import { CurrencyMemoView, MemoRelatedDocsView } from './MemoRelatedDocsView';
import { CustomerEntityView } from "@app/shared/models/CustomerEntityView";
import { MemoPeriodicView } from "@app/shared/views/MemoPeriodicView";
import { MemoContentOriginView } from '@app/shared/views/MemoContentOriginView';
import { FileTypeView } from '@app/shared/views/FileTypeView';
import { AgentsMacroGroupView } from '@app/shared/views/AgentsMacroGroupView';
import { MemoStatusView } from '@app/shared/views/MemoStatusView';
import { RemoteAccountView } from "@app/shared/views/RemoteAccountView";

import { default as constantsFile } from '@app/shared/constants.json';

export class MemoPaymentView {
  public memoPaymentId?: number;
  public airline: string;
  public bsp: string;
  public contactEmail: string;
  public contactName: string;
  public contactPhone: string;
  public creationTime?: Date;
  public currentDocument?: string;
  public currentDocumentAdm?: string;
  public requestAirlineAudit: boolean;
  public isExcel: boolean;
  public endTaskDate?: Date;
  public fileSequence: number;
  public fileName: string;
  public frequency: string;
  public fromDocument: string;
  public fromDocumentAdm: string;
  public issueDate?: Date;
  public maxRelated: number;
  public memoContent?: string;
  public parentId?: number;
  public paymentType: string;
  public reasonForMemo?: string;
  public responseTime?: Date;
  public rmic?: string;
  public sendTime?: Date;
  public startTaskDate?: Date;
  public templateExpired?: Date;
  public toDocument: string;
  public toDocumentAdm: string;
  public vat?: string;
  public xml?: string;
  public totalAmount: string;
  public isSFTPUploadable: boolean;
  public HasRelatedAttachments?: boolean;
  public periodFrom: number;
  public periodTo: number;


  // Objectos relacionados.
  public agentsMacroGroup: AgentsMacroGroupView;
  public customer: CustomerEntityView;
  public docType: FileTypeView;
  public memoContentOrigin: MemoContentOriginView;
  public memoPeriodic: MemoPeriodicView;
  public memoStatus: MemoStatusView;
  public remoteResponse: RemoteAccountView;
  public remoteUpload: RemoteAccountView;
  // Son solo variables de apoyo.
  public bIsReprocessable: boolean;
  public hasRelatedAttachments?: boolean;
  public sCreationTime?: string;
  public sEndTaskDate?: string;
  public sFromDocument: string;
  public sIsPeriodic?: string;
  public sIssueDate?: string;
  public sPaymentTypeTranslated?: string;
  public sResponseTime?: string;
  public sStartTaskDate: string;
  public sSendTime?: string;
  public sToDocument: string;
  public oMemosList?: MemoRelatedDocsView;
  public currency?: CurrencyMemoView;
  public totalAmountValue?: number;

  constructor() {
    const constants = constantsFile.constants;
    // Valores por defecto.
    this.paymentType = constants.paymentTypes.commission;
    this.memoPeriodic = new MemoPeriodicView();
  }
}
